import EFPicture from '@elem/compCommon/EFPicture';
import { TestimonialItem } from './components/Carousel';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import dynamic from 'next/dynamic';
// 客户评价数据

const HomeCarousel = dynamic(() => import('./components/Carousel'), {
    ssr: false, // ← 关键：彻底避免 window 报错 & hydration 问题
});

export default function Installation() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const testimonials: TestimonialItem[] = [
        {
            text: t('sec_installation_sample1'),
            name: 'Michael C.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1770611605132/image%205156244.png',
            h5Image: 'https://websiteoss.ecoflow.com/upload/image/1770692447631/image%205156247%20(1).png',
        },
        {
            text: t('sec_installation_sample2'),
            name: 'Nathan O.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1770611605374/image%205156245.png',
            h5Image: 'https://websiteoss.ecoflow.com/upload/image/1770692447451/image%205156248%20(1).png',
        },
        {
            text: t('sec_installation_sample3'),
            name: 'Jason B.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1770611605547/image%205156246.png',
            h5Image: 'https://websiteoss.ecoflow.com/upload/image/1770692447296/image%205156246%20(1).png',
        },
        {
            text: t('sec_installation_sample1'),
            name: 'Michael C.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1770611605132/image%205156244.png',
            h5Image: 'https://websiteoss.ecoflow.com/upload/image/1770692447631/image%205156247%20(1).png',
        },
        {
            text: t('sec_installation_sample2'),
            name: 'Nathan O.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1770611605374/image%205156245.png',
            h5Image: 'https://websiteoss.ecoflow.com/upload/image/1770692447451/image%205156248%20(1).png',
        },
        {
            text: t('sec_installation_sample3'),
            name: 'Jason B.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1770611605547/image%205156246.png',
            h5Image: 'https://websiteoss.ecoflow.com/upload/image/1770692447296/image%205156246%20(1).png',
        },
    ];
    return (
        <section className={`dpu-detail-installation dpu-detail-section ${css['dpu-detail-installation']}`}>
            <div className={`img-box`}>
                <EFPicture
                    src={'https://websiteoss.ecoflow.com/upload/image/1770606709046/02.png'}
                    srcPad={'https://websiteoss.ecoflow.com/upload/image/1770626662559/Frame%201612707730%20(1)%20(1).png'}
                    srcMobile={'https://websiteoss.ecoflow.com/upload/image/1770626662559/Frame%201612707730%20(1)%20(1).png'}
                    alt={t('secA_title')}
                />
            </div>
            <div className={'info-box'}>
                <h1 className="title">
                    {t.rich('sec_installation_title', {
                        gradient: (text: string) => <span className="number-gradient">{text}</span>,
                    })}
                </h1>
                <p className="desc">
                    {t.rich('sec_installation_desc', {
                        bold: (text: string) => <span className="bold-text">{text}</span>,
                    })}
                </p>
                <HomeCarousel testimonials={testimonials} />
            </div>
        </section>
    );
}
